<template>
    <el-dialog v-model="isVisible"  :show-close="false" width="1483" align-center :destroy-on-close="true" @close="close">
      <template #header="{}">
        <div class="my-header">
          <div>{{ $t("smart_OM_model.smart_OM") }}</div>
          <el-icon class="cursor-pointer" @click="close" color="#fff" ><Close /></el-icon>
        </div>
      </template>
     <div class="outside-center d-flex" >
      <!-- 左 -->
       <div class="left-part">
        <div class="left-part1">
          <Top :name="$t('smart_OM_model.model_status')" :show-switch="true" :switchValue="isRunning" @switchChange="handleRunning" :lineType="'2'"></Top>
          <!-- status-button-close -->
          <div class="status-button mt-4">
            <img v-if="isRunning" class="outerAnimation" src="../../../assets/images/dashboard/running_btn.png" alt="">
            <img v-else src="../../../assets/images/dashboard/closed_btn.png" alt="">
          </div>
          <div class="mt-4 mb-4">{{ isRunning?$t("smart_OM_model.start_time"):$t("smart_OM_model.end_time")}} : {{ startEndDate }}</div>
          <div class="mb-2">{{ $t("smart_OM_model.intelligent_total_running_time") }}:  <span style="color: #13C56B;">{{ totalDuration }} h</span></div>
        </div>
        <div class="left-part2">
          <SelectsTop :name="$t('smart_OM_model.key_metrics_trend')" 
            :button-name="`${currentSelect.length} ${$t('smart_OM_model.items_selected')}`" 
            :defaultCheckedKeys="default_checked_keys"
            @handleCurrentSelect="handleCurrentSelect" 
            :lineType="'2'"></SelectsTop>
          <div class="mt-2 mb-2 fs-14">{{ $t("smart_OM_model.last_updated") }}： {{ timestamp||"-"}} </div>
          <div id="miniEcharts" style="width: 100%;height: 338px;"></div>
        </div>
       </div>
      <!-- 右 -->
       <div class="right-part flex-1 ms-3">
        <!-- Real-time Monitoring -->
        <div class="right-part1">
          <Top :name="$t('smart_OM_model.real_time_monitoring')" :show-button="false" :buttonName="'Energy Efficiency'" :buttonClick="clickTo" :lineType="'1'"  
          :buttonStyle="{backgroundColor: '#22BBE8',height:'27px',border:'none',fontSize:'14px'}" ></Top>
          <div class="position-relative">
            <!-- 提示框 -->
            <div class="tip d-flex position-absolute">
              <div style="width: 100px;">
                <div class="mb-2">Pr：{{$t("smart_OM_model.pressure")}}</div>
                <div class="mb-2">Pw：{{$t("smart_OM_model.power")}}</div>
                <div class="mb-2">Q：{{$t("smart_OM_model.flow_rate")}}</div>
                <div>MS：{{$t("smart_OM_model.motor_speed")}}</div>
              </div>
              <div class="flex-1">
                <div>T：{{$t("smart_OM_model.temperature")}}</div>
                <div class="mt-2 mb-2">MF：{{ $t("smart_OM_model.motor_frequency") }}</div>
                <div>I：{{ $t("smart_OM_model.current") }}</div>
              </div>
            </div>
            <!-- 测点名称 -->
            <template v-for="item in configurationDiagramList" :key="item.name">
              <div class="position-absolute d-flex align-items-center" :style="item.pos">
                 <div :class="['circle-dot',item.is_run&&'circle-dot-run']"></div>
                 <div class="ms-2">
                   <template v-if="item.name == '3#Liquid ring'">
                    {{ $t("smart_OM_model.liquid_ring")  }}
                   </template>
                   <template v-else-if="item.name == '1#Roots'">
                    {{ $t("smart_OM_model.one_roots")  }}
                   </template>
                   <template v-else-if="item.name == '2#Roots'">
                    {{ $t("smart_OM_model.two_roots")  }}
                   </template>
                   <template v-else>
                    {{ item.name  }}
                   </template>
                 </div>
              </div>
            </template>
            <!-- 测点阀门 -->
            <template v-for="item in lavesControl" :key="item.name">
              <img class="position-absolute" :src="item.is_run?valveOpeningSvg:valveCloseSvg" alt="" :style="`width:28px;height: 39.5px;${item.pos}`">
            </template>
            <!-- 右侧特殊样式测点 -->
            <div class="position-absolute meas-div" style="min-width: 122px;top:252px;right:-10px;">
              <div class="div-bg d-flex align-items-center">
                <div style="width: 25px;">T2</div><span style="margin-right: 1px;">:</span><div style="margin-right: 3px;min-width:40px;">
                  <!-- 冷却水入口温度 -->
                  {{ws_v["Condenser Cooling Water Inlet Temperature"]&&ws_v["Condenser Cooling Water Inlet Temperature"].v||"-"}}</div><div>℃</div>
                  <!-- 箭头 -->
                  <div style="margin-left: 16px;">
                    <img v-if="ws_v['Condenser Cooling Water Inlet Temperature']&&ws_v['Condenser Cooling Water Inlet Temperature'].isArrow&&ws_v['Condenser Cooling Water Inlet Temperature'].isArrow.includes('equivalent_icon')" 
                    :src="ws_v['Condenser Cooling Water Inlet Temperature'].isArrow" alt="" style="height:6.17px;width:14.8px;">
                    <img v-else :src="ws_v['Condenser Cooling Water Inlet Temperature'].isArrow" alt="" style="width:6.17px;height:14.8px;">
                  </div>
              </div>
              <div class="div-bg d-flex align-items-center">                 
                  <div :class="['circle-dot',ws_v['冷却水高速给水泵运行状态']&&(ws_v['冷却水高速给水泵运行状态'].v != '-')&&ws_v['冷却水高速给水泵运行状态'].v&&'circle-dot-run']"></div>
                  <div class="ms-2">{{ $t("smart_OM_model.water_pump") }}</div>
              </div>
              <div  class="div-bg">{{ $t("smart_OM_model.two_speed_pump") }}：</div>
              <div class="div-bg d-flex align-items-center">                 
                  <div :class="['circle-dot',ws_v['冷却水双速给水泵高速运行状态']&&(ws_v['冷却水双速给水泵高速运行状态'].v != '-')&&ws_v['冷却水双速给水泵高速运行状态'].v&&'circle-dot-run']"></div>
                  <div class="ms-2">{{ $t("smart_OM_model.high_speed") }}</div>
              </div>
              <div class="div-bg d-flex align-items-center">                 
                  <div :class="['circle-dot',ws_v['冷却水双速给水泵低速运行状态']&&(ws_v['冷却水双速给水泵高速运行状态'].v != '-')&&ws_v['冷却水双速给水泵低速运行状态'].v&&'circle-dot-run']"></div>
                  <div class="ms-2">{{ $t("smart_OM_model.low_speed") }}</div>
              </div>
            </div>
            <!-- 测点盒子 -->
            <template v-for="item in measurementsList" :key="item.id">
              <table class="position-absolute meas-table" :style="`min-width: 122px;${item.pos}`">
                <tr v-for="(meas) in item.list" :key="meas.name" :class="[isRunning&&meas.name.includes('MS')&&'blink']">
                  <td style="padding-left: 8px">{{ meas.name == ""?$t("smart_OM_model.t_sealing_water"):meas.name }}</td>
                  <td>:</td>
                  <td style="padding-left: 3px;padding-right: 3px;min-width: 39px;">{{ meas.value }}</td>
                  <td style="padding-left: 3px;padding-right: 3px;">{{ meas.unit }}</td>
                  <td style="padding-left: 3px;padding-right: 3px;width: 15px;">
                    <templat v-if="meas.isAscShow&&meas.isArrow">
                      <img v-if="meas.isArrow.includes('equivalent_icon')" :src="meas.isArrow" alt="" style="height:6.17px;width:14.8px;">
                      <img v-else :src="meas.isArrow" alt="" style="width:6.17px;height:14.8px;">
                    </templat>
                  </td>
                </tr>
              </table>
            </template>
            <!-- 液位 -->
            <div class="position-absolute d-flex flex-column align-items-center" style="bottom:180px;left:45px;">
              <div>{{$t("smart_OM_model.separator_level") }}: </div>
              <!-- <div>汽水分离器液位: </div> -->
              <div>{{ ws_v["Separator level"]&&ws_v["Separator level"].v  || "-"}} mm
                <img v-if="ws_v['Separator level']&&ws_v['Separator level'].isArrow&&ws_v['Separator level'].isArrow.includes('equivalent_icon')" :src="ws_v['Separator level'].isArrow" alt="" style="height:6.17px;width:14.8px;">
                <img v-else :src="ws_v['Separator level'].isArrow" alt="" style="width:6.17px;height:14.8px;">
              </div>
            </div>
            <img id="big-img" :src="aircrewImage?smartOMValveSvg:smartOMNoValveSvg" alt="">
          </div>
          <!-- Condenser -->
           <div class="position-absolute" style="top:205px;right:173px;">{{ $t("smart_OM_model.condenser") }}</div>
        </div>
        <!-- Model Logs -->
        <div class="right-part2">
          <Top :name="$t('smart_OM_model.model_logs')" :show-button="false" :lineType="'1'"></Top>
          <div class="model-log position-relative flex-1" >
            <template v-for="(item, index) in modelLog" :key="index">
              <div class="date-box-item position-absolute" :style="modelLogPos[index]">
                {{ item }}
              </div>
            </template>
            <img :src="isRunning?running_icon:true_icon" alt="" :class="['position-absolute',`${isRunning?'running-icon':'true-icon'}`]">
            <div v-if="isRunning" class="position-absolute d-flex flex-column align-items-center" style="font-size:14px;bottom:0px;right:95px;">
              <div>Target Frequency: 34</div>
              <div class="d-flex align-items-center justify-content-center" style="width: 207px;">
                <span class="me-1">Last Command: Add to {{ randomNumber }}</span> 
                <!-- 上升ascend或下降decline -->
                 <template v-if="randomNumberArrow">
                   <img v-if="randomNumberArrow.includes('equivalent_icon')" :src="randomNumberArrow" alt="" style="height:6.17px;width:14.8px;">
                   <img v-else :src="randomNumberArrow" alt="" style="width:6.17px;height:14.8px;">
                 </template>
              </div>
            </div>
            <img src="../../../assets/images/dashboard/smart_logs.png" alt="" style="height: 22px;margin: 55px 0;">
          </div>
        </div>
       </div>
     </div>
    </el-dialog>
  </template>
  
  <script>
  import { Close } from '@element-plus/icons-vue';
  import { ref } from 'vue';
  import SelectsTop from '@/components/common/SelectsTop.vue';
  import moment from 'moment';
  import { spectrumEcharts3 } from "@/utils/chart";
  import { formatNumber,formatNumber1 } from "@/utils/common.js";
  import { SOCKET_SVC_HOST } from "@/config/common.js";
  import { getRawTimeseries, login } from "@/service/index";
  import _, { includes } from "lodash";
  import qs from "qs";
  import * as echarts from "echarts";
  import { mapState, mapActions } from 'vuex';
  import i18n from "@/i18n";
  export default {
    emit:["closeDialog","handleCurrentState"],
    props:{
      visible:{
        type:Boolean,
        default:false,
      }
    },
    data() {
      return {
        smartOMNoValveSvg:require("@/assets/images/dashboard/smart_om_no_valve.svg"),//没有阀门的机组图片
        smartOMValveSvg:require("@/assets/images/dashboard/smart_o_m.gif"), //有阀门的机组图片
        valveCloseSvg:require("@/assets/images/dashboard/valve_close.svg"),
        valveOpeningSvg:require("@/assets/images/dashboard/valve_opening.svg"),
        /*模型的运行是周期性（根据算法的定义）的，可能一周或一天运行一次，模型运行达到理想效果时就会停止，然后等待一段时间再去运行下一次*/ 
        isRunning:true, //模型是否运行
        true_icon:require("@/assets/icon-font/true_icon.svg"), //运行完一个周期
        running_icon:require("@/assets/icon-font/running.svg"), //运行当中
        asc_icon:require("@/assets/icon-font/asc_icon.svg"),//上升
        dec_icon:require("@/assets/icon-font/dec_icon.svg"),//下降
        equivalent_icon:require("@/assets/icon-font/equivalent_icon.svg"),//相等
        currentSelect:[],//默认展示前2个测点echart
        default_checked_keys:[],
        randomNumber:18,//随机数
        randomNumberArrow:null,
        timer:null,
        /* 左侧测点 */ 
        leftMeasurementsList:[],
        modelLogPos:[
          'top:18px;right:115px;',
          'bottom:25px;right:300px;',
          'top:25px;left:410px;',
          'bottom:25px;left:230px;',
          'top:25px;left:75px;',
        ],
        modelLog:[],
       /* 组态图测点列表 */
       configurationDiagramList:[
          { is_run: false, name:'1#V',full_name:"真空泵组入口阀全开状态/真空泵组入口阀全关状态", pos:'font-size:14px;right:330px;top:170px'},
          { is_run: false, name:'2#V',full_name:"罗茨泵平衡阀开关指令", pos:'font-size:14px;right:552px;top:170px'},
          { is_run: false, name:'3#V',full_name:"汽水分离器补水电磁阀开关指令", pos:'font-size:14px;left:-10px;top:245px'},
          { is_run: false, name:'3#Liquid ring',full_name:"水环真空泵电机运行状态", pos:'font-size:14px;left:212px;bottom:55px'},
          { is_run: false, name:'2#Roots',full_name:"二级罗茨真空泵电机运行状态", pos:'font-size:14px;top:205px;left:442px;'},
          { is_run: false, name:'1#Roots',full_name:"一级罗茨真空泵电机运行状态", pos:'font-size:14px;top:205px;left:572px;'},
        ],
        /* 三个阀门开关 */ 
        lavesControl:[
          { is_run: false, name:'1#V',full_name:"真空泵组入口阀全开状态/真空泵组入口阀全关状态", pos:'font-size:14px;right:335px;top:135px'},
          { is_run: false, name:'2#V',full_name:"罗茨泵平衡阀开关指令", pos:'font-size:14px;right:575px;top:135px'},
          { is_run: false, name:'3#V',full_name:"汽水分离器补水电磁阀开关指令", pos:'font-size:14px;left:7px;top:208px'},
        ],
        /* 
        右侧测点列表
        isAscShow:是否显示升降序符号
        isArrow:箭头
        name:测点名称
        full_name:测点全称
        value:测点值
        unit:测点单位
         */
        measurementsList:[
          {
            id:1,
            pos:'top:78px;left:323px',
            list:[
            { isAscShow:true, isArrow:null, name:'2#T2', full_name: "2#Roots Outlet Temperature", value:'-', unit:'°C'},
            ],
          },
          {
            id:2, 
            pos:'top:50px;left:455px',
            list:[
              { isAscShow:true, isArrow:null, name:'2#Pr', full_name: "2#Roots Inlet Pressure", value:'-', unit:'kPa.A'},
              { isAscShow:true, isArrow:null, name:'2#T1', full_name: "2#Roots Inlet Temperature", value:'-', unit:'°C'},
            ],
          },
          {
            id:3, 
            pos:'top:50px;left:600px',
            list:[
              { isAscShow:true, isArrow:null, name:'1#Pr', full_name: "1#Roots Inlet Pressure", value:'-', unit:'kPa.A'},
              { isAscShow:true, isArrow:null, name:'1#T', full_name: "1#Roots Inlet Temperature", value:'-', unit:'°C'},
            ],
          },
          {
            id:4, 
            pos:'top:5px;right:-12px',
            list:[
              { isAscShow:true, isArrow:null, name:'Pw', full_name: "Condenser Active Power", value:'-', unit:'MW'},
              { isAscShow:true, isArrow:null, name:'Pr', full_name: "Condenser Inlet Pessure", value:'-', unit:'kPa.A'},
              { isAscShow:true, isArrow:null, name:'T1', full_name: "Condenser Inlet Temperature", value:'-', unit:'°C'},
            ],
          },
          {
            id:5, 
            pos:'top:222px;left:400px',
            list:[
              { isAscShow:true, isArrow:null, name:'2#MF', full_name: "二级罗茨真空泵电机变频运行频率", value:'-', unit:'Hz'},
              { isAscShow:true, isArrow:null, name:'2#MS', full_name: "2#Roots Motor Speed", value:'-', unit:'rpm'},
              { isAscShow:true, isArrow:null, name:'2#I', full_name: "2#Roots Current", value:'-', unit:'A'}, //电流
              { isAscShow:true, isArrow:null, name:'2#Pw', full_name: "2#Roots Power", value:'-', unit:'kW'},
            ],
          },
          {
            id:6, 
            pos:'top:222px;left:538px',
            list:[
              { isAscShow:true, isArrow:null, name:'1#MF', full_name: "一级罗茨真空泵电机变频运行频率", value:'-', unit:'Hz'},
              { isAscShow:true, isArrow:null, name:'1#MS', full_name: "1#Roots Motor Speed", value:'-', unit:'rpm'},
              { isAscShow:true, isArrow:null, name:'1#I', full_name: "1#Roots Current", value:'-', unit:'A'},//电流
              { isAscShow:true, isArrow:null, name:'1#Pw',  full_name: "1#Roots Power", value:'-', unit:'kW'},
            ],
          },
          {
            id:7, 
            pos:'top:264px;left:675px',
            list:[
              { isAscShow:true, isArrow:null, name:'T3', full_name: "冷却水出口温度", value:'-', unit:'°C'},
            ],
          },
          {
            id:8, 
            pos:'bottom:87px;right:126px',
            list:[
              { isAscShow:true, isArrow:null, name:'T4', full_name: "Condenser Outlet Temperature", value:'-', unit:'°C'},
              { isAscShow:true, isArrow:null, name:'Q', full_name: "凝结水出口流量", value:'-', unit:'m³/s'},
            ],
          },
          {
            id:9, 
            pos:'bottom:67px;left:377px',
            list:[
              { isAscShow:true, isArrow:null, name:'3#Pr', full_name: "3#Liquid Ring Inlet Pressure", value:'-', unit:'kPa.A'},
              { isAscShow:true, isArrow:null, name:'3#T', full_name: "3#Liquid Ring Inlet Temperature", value:'-', unit:'°C'},
              { isAscShow:true, isArrow:null, name:'3#MF', full_name: "水环真空泵电机变频运行频率", value:'-', unit:'Hz'},
            ],
          },
          {
            id:10, 
            pos:'bottom:-20px;left:377px',
            list:[
              { isAscShow:true, isArrow:null, name:'3#MS', full_name: "3#Liquid Ring Motor Speed", value:'-', unit:'rpm'},
              { isAscShow:true, isArrow:null, name:'3#I', full_name: "3#Liquid Ring Current", value:'-', unit:'A'}, //电流
              { isAscShow:true, isArrow:null, name:'3#Pw', full_name: "3#Liquid Ring Power", value:'-', unit:'kW'},
            ],
          },
          {
            id:11, 
            pos:'bottom:-9px;left:43px',
            list:[
              { isAscShow:true, isArrow:null, name:i18n.global.t("smart_OM_model.t_sealing_water"), full_name: "Sealing Water Tempteraure", value:'-', unit:'°C'},
            ],
          },
        ],
        ws_v:{},
        myChart:null,
        retryCount:0,
        timestamp:'',
        startEndDate:'',//运行的开始时间或结束时间
        shadowIdList:[],

      }
    },
    mounted(){
      this.isRunning = this.$store.state.equipManagement.isRunning
      this.$store.commit( "equipManagement/set_is_running", this.isRunning);

      // log日志逻辑
      let list = JSON.parse(sessionStorage.getItem('modelLogDate'))||[]
      if(list.length){
         this.modelLog = list
      }else{
        for (var i = 0; i < 5; i++) {
          if(i>0){
            this.modelLog.push(moment().subtract(2*i, 'days').format("YYYY.MM.DD")+' 07:48 AM')
          }else{
            this.modelLog.unshift(moment().format("YYYY.MM.DD")+' 07:48 AM') 
          }
        }
      }
      this.startEndDate = moment(this.modelLog[0]).format('YYYY-MM-DD HH:mm:ss')
      sessionStorage.setItem('modelLogDate',JSON.stringify(this.modelLog))

      this.generateRandomNumber() //周期log随机增加数
      this.getHistoryData() //获取历史数据
      this.initWebSocket() //实时数据
    },
    beforeUnmount(){
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    computed:{
      isVisible(){
        return this.visible;
      },
      equip_data() {
        return _.cloneDeep(this.$store.state.equipManagement.equipData);
      },
      measurements() {
        let measur = []
        let info = _.cloneDeep(this.$store.state.equipManagement.equipData)
        if(info&&info.attributes){
          if(info.attributes.measurements.length){
            let list  = info.attributes.measurements.map(item=>{
              return {equipment_id:info.id ,...item}
            })
            measur = [...list]
          }
          if(info.children){ //机组需要获取子设备测点数据
            info.children.map(item=>{
              if(item.attributes&&item.attributes.measurements){
                let list  = item.attributes.measurements.map(an=>{
                  return {equipment_id:item.id ,...an}
                })
                measur = [...measur, ...list]
              }
            })
          }
        }
        return measur;
      },
      /* 获取测点组别,获取历史数据 */ 
      measurementsGroup() {
        let measur = {}
        let info = _.cloneDeep(this.$store.state.equipManagement.equipData)

        if(info&&info.attributes){
          measur[info.id] = info.attributes.measurements
          if(info.children){ //机组需要获取子设备测点数据
            info.children.map(item=>{
              if(item.attributes&&item.attributes.measurements){
                measur[item.id] = item.attributes.measurements
              }
            })
          }
        }
        return measur;
      },
      totalDuration(){ //白杨河展示运行市场
        return this.$store.state.equipManagement.totalDuration
      },
      /* 机组是否运行，动态图根据 3#Liquid ring   2#Roots  1#Roots 3个泵相关,有一个开启，就动态图，全部关闭为静态图*/ 
      aircrewImage(){
        return this.configurationDiagramList.slice(3,6).some(item=>item.is_run)
      }
    },
    watch: {
      ws_v:{
        handler(val){
          //重写遍历数组
          this.configurationDiagramList.forEach((item,index)=>{
            if (item.full_name === "真空泵组入口阀全开状态/真空泵组入口阀全关状态") {
                //1#V   1#V的圆点显示规则：如果全开状态是1，阀门和圆点就亮起来，如果全关状态是1，阀门和圆点就变灰
                if(val["真空泵组入口阀全开状态"].v == 1){
                  item.is_run = true
                }else if(val["真空泵组入口阀全关状态"] == 1){
                  item.is_run = false
                }else{
                  item.is_run = false
                }
            }else{
              if(val[item.full_name].v == 1){
                item.is_run = true
              }else{
                item.is_run = false
              }
            }
            /* 设置阀门开关 1#V 2#V 3#V*/ 
            if (this.lavesControl[index]) {
              this.lavesControl[index].is_run =  item.is_run
            }
          }) 
        },deep:true,
        }
      },
    methods:{
      moment,
      close(){
        this.$emit("closeDialog")
      },
      handleRunning(val){
        
        if(!this.isRunning){ //点击之前停运状态
          this.modelLog.pop()
          this.modelLog.unshift(moment().format("YYYY.MM.DD HH:mm A")) 
          this.startEndDate = moment().format('YYYY-MM-DD HH:mm:ss')//运行时间
        }else{//点击之前运行状态
          this.startEndDate = moment().format('YYYY-MM-DD HH:mm:ss')//运行时间
        }
        this.isRunning = val
        sessionStorage.setItem("modelLogDate",JSON.stringify(this.modelLog))

        this.$store.commit( "equipManagement/set_is_running", this.isRunning);
        
      },
      generateRandomNumber() {
        // 使用 setInterval 每隔5秒生成一个1-20的随机数，并存储定时器ID
        this.timer = setInterval(() => {
          let value = Math.floor(Math.random() * 20) + 1;
          if(this.randomNumber>value){
            this.randomNumberArrow = this.dec_icon //下降
          }else if(this.randomNumber == value){
            this.randomNumberArrow = this.equivalent_icon //相等
          }else{
            this.randomNumberArrow = this.asc_icon //上升
          }
          this.randomNumber = value
        }, 5000); // 5000毫秒 = 5秒
      },
      clickTo(){
        //  跳转能耗分析页面/equipment-detail?index=1&equip_id=5ac59500-70e3-11ef-a113-4bd278884fe5&type=energyConsumptionAnalysis&isShowEcharts=false
        this.$router.push({
          path:'/equipment-detail',
          query:{
            index:1,
            equip_id:'5ac59500-70e3-11ef-a113-4bd278884fe5',
            type:'energyConsumptionAnalysis',
            isShowEcharts:false
          }
        })
      },
      /* 更新展示测点 */ 
      handleCurrentSelect(indexs){
        const normalizedSelect = Array.isArray(indexs)
          ? indexs.map((item) => String(item))
          : []
        this.currentSelect = normalizedSelect

        this.leftMeasurementsList.forEach((i,index)=>{
          if(this.currentSelect.includes(String(i.measurement_id))){
            i.is_checked = true
          }else{
            i.is_checked = false
          }
        })

        if(this.currentSelect.length == 0){
          this.updateChart([],false) //更新图表
        }else{
          this.updateChart(this.leftMeasurementsList,false) //只更新series数据
        }
      },
      /* 获取历史测点数据 */
      getHistoryData(){
        this.currentSelect = []
        this.default_checked_keys = []
        this.leftMeasurementsList = []
        this.shadowIdList = []
        this.ws_v = {}

        var column = [];
        let count = 0; // 计数变量
        this.measurements.forEach((item,index)=>{
          if (item.is_show && count < 2) { // 判断是否满足条件且未超过两个
            this.currentSelect.push(String(item.id));
            count++; // 计数加1
          }
          const wsKey = this.isCurrentORDefault(item.equipment_id,item.name)
          const sharedWsState = this.ws_v[wsKey] || { v:'-', isArrow:null }
          this.ws_v[wsKey] = sharedWsState
          // 兼容 name/full_name/key 命名方向不一致的测点（如 2#MF）
          ;[item.full_name, item.key, item.name].forEach((aliasKey) => {
            const normalizedAliasKey = typeof aliasKey === "string" ? aliasKey.trim() : ""
            if (!normalizedAliasKey || normalizedAliasKey === wsKey || normalizedAliasKey === "电流") return
            this.ws_v[normalizedAliasKey] = sharedWsState
          })
          column.push(item.key)
          let obj = {
              name: item.name,
              full_name: item.full_name,
              key: item.key,
              ids: this.equip_data.id,
              equipment_id:item.equipment_id,
              measurement_id:item.id,
              unit: item.unit,
              series_id:`${item.equipment_id}::${item.key}`,
              data: [],
              type: "line",
              dtype:item.dtype,
              showSymbol: false,
              is_checked: false,
              lineStyle: {
                //设置线条默认样式
                normal: {
                  width: 1,
                },
                //设置线条hover样式
                emphasis: {
                  // 鼠标hover上去的时候，拐点的颜色和样式
                  itemStyle: {
                    color: "#fff", //颜色
                    borderColor: "#0072FF", //图形的描边颜色
                    borderWidth: 3, // 描边的线宽
                    shadowBlur: 1, // 图形的阴影大小
                    shadowColor: "#0072FF", // 图形的阴影颜色
                  },
                },
              },
              markPoint: {
                data: [],
              },
              markLine: {
                data: [],
              },
            }
            if(this.currentSelect.includes(String(item.id))){
              obj.is_checked = true
            }
          this.leftMeasurementsList.push(obj)
        })
        this.default_checked_keys = this.currentSelect
        this.$nextTick(()=>{
          let allRequests = [];
          for (let key in this.measurementsGroup) {
            this.shadowIdList.push(key)
            if (this.measurementsGroup[key].length) {
              let measurement_key = this.measurementsGroup[key].map(item => item.key);
              let paramsdata = {
                start: '10m',
                end: '0m',
                limit: 14,
                measurement_key,
              };
              let params = qs.stringify(paramsdata, { arrayFormat: "repeat" });

              // 将请求添加到 allRequests 数组中
              allRequests.push(
                getRawTimeseries(key, params).then(ress => ({
                  key,
                  data: ress
                }))
              );
            }
          }

          // 等待所有请求完成后处理数据
          Promise.all(allRequests)
            .then(results => {
              // 设备维度分别回填，避免同 key 测点互相覆盖
              results.forEach((result) => {
                const shadowId = result.key
                const payload = result?.data?.payload || []
                if (payload.length) {
                  this.timestamp = moment(result.data.timestamp).format("YYYY.MM.DD HH:mm")
                }
                const deviceSeries = this.leftMeasurementsList.filter(
                  (series) => series.equipment_id === shadowId
                )
                payload.forEach((recordItem) => {
                  const ts = moment(recordItem.ts)
                    .format("YYYY-MM-DD HH:mm:ss.SSS")
                    .valueOf()
                  deviceSeries.forEach((series) => {
                    if (!Object.prototype.hasOwnProperty.call(recordItem, series.key)) return
                    const value = formatNumber(recordItem[series.key])
                    series.data.push({
                      name: ts,
                      value: [ts, value, shadowId],
                    })
                    if (series.data.length > 14) {
                      series.data.shift()
                    }
                  })
                })
              })

              this.leftMeasurementsList.forEach((s, i) => {
                s.yAxisIndex = i
                if (s.data && s.data[s.data.length - 1] && s.data[s.data.length - 2]) {
                  const name = this.isCurrentORDefault(s.equipment_id, s.name)
                  if (!this.ws_v[name]) {
                    this.ws_v[name] = { v: "-", isArrow: null }
                  }
                  this.ws_v[name].v = s.data[s.data.length - 1].value[1]

                  if (this.ws_v[name].v > s.data[s.data.length - 2].value[1]) {
                    this.ws_v[name].isArrow = this.dec_icon //下降
                  } else if (this.ws_v[name].v == s.data[s.data.length - 2].value[1]) {
                    this.ws_v[name].isArrow = this.equivalent_icon //相等
                  } else {
                    this.ws_v[name].isArrow = this.asc_icon //上升
                  }
                }
              })
              this.measurementsList.forEach(item=>{
                  item.list.forEach(i=>{
                    const wsState = this.getWsState(i)
                    if (wsState) {
                      i.value = wsState.v
                      i.isArrow = wsState.isArrow
                    }
                  })
                })

            }).finally(() => {
              this.$nextTick(() => {
                this.updateChart(this.leftMeasurementsList,false) //初始化echarts
              });
              this.myChart && this.myChart.hideLoading();
            })
        })
      },
      /**
       * 
       * @param dataLists series数据
       * @param falg 只更新series数据
       */
      updateChart(dataLists,falg){
        spectrumEcharts3({
          chartDom: document.getElementById("miniEcharts"),
          dataLists,
        },falg);
      },
      initWebSocket(){
        const interval = setInterval(() => {
          if (this.retryCount > 10) {
            clearInterval(interval)
            this.retryCount = 0
            return
          }
          const stompClient = this.$websocket.getters.stompClient()
          if (stompClient != null && stompClient.connected) {
            clearInterval(interval)
            stompClient.subscribe("/topic/stream", msg => {
              if (msg && msg.body) {
                let websocketdata = Array.isArray(JSON.parse(msg.body)) ? JSON.parse(msg.body) : [JSON.parse(msg.body)];
                /* 避免其他页面触发 */ 
                  if (this.$route.path == "/VSD420-OverAll") {   
                    /*  获取推送数据,处理 */ 
                    this.getWebsocket(websocketdata)
                  }
              }
            })
          } else {
            if (!sessionStorage.getItem("accessToken")) return
            const _url = SOCKET_SVC_HOST + "/messaging/stomp?access_token=" + sessionStorage.getItem("accessToken");
            this.$websocket.dispatch('WEBSOCKET_INIT', _url)
          }
          this.retryCount++
        }, 1000)
      },
      // 获取推送数据,处理
      getWebsocket(socdata) {
        if ( socdata && socdata.length ) {
          socdata.map((soc) => {
            /* 匹配推送的对应设备的id */ 
            if(this.shadowIdList.includes(soc.shadowId)&&soc.report.length){
              for(let item of soc.report){
              /* 复制对应测点值 */
              let _index = this.leftMeasurementsList.findIndex(
                (i) => i.equipment_id === soc.shadowId && i.key === item.id
              )
              if(_index >-1){
                  const value = formatNumber(item.v)
                  this.leftMeasurementsList[_index].data.push({
                    name: moment().format("YYYY-MM-DD HH:mm:ss.SSS").valueOf(),
                    value: [ moment().format("YYYY-MM-DD HH:mm:ss.SSS").valueOf(), value, soc.shadowId ],
                  })
                  if (this.leftMeasurementsList[_index].data.length > 14) {
                    this.leftMeasurementsList[_index].data.shift()
                  }
                  const name = this.isCurrentORDefault(this.leftMeasurementsList[_index].equipment_id,this.leftMeasurementsList[_index].name) 
                  if (!this.ws_v[name]) {
                    this.ws_v[name] = { v: "-", isArrow: null }
                  }
                  //只更新的数据做修改
                  if(this.ws_v[name].v){
                    if(this.ws_v[name].v>value){
                      this.ws_v[name].isArrow = this.dec_icon //下降
                    }else if(this.ws_v[name].v == value){
                      this.ws_v[name].isArrow = this.equivalent_icon //相等
                    }else{
                      this.ws_v[name].isArrow = this.asc_icon //上升
                    }

                    this.ws_v[name].v = value
                  }else{
                    this.ws_v[name].v = value
                  }
              }
            }
            this.timestamp = moment().format("YYYY.MM.DD HH:mm")
            this.measurementsList.forEach(item=>{
              item.list.forEach(i=>{
                const wsState = this.getWsState(i)
                if (wsState) {
                  i.value = wsState.v
                  i.isArrow = wsState.isArrow
                }
              })
            })

            this.$nextTick(()=>{
              this.updateChart(this.leftMeasurementsList,true) // 只更新series数据
            })
            }
          });
        }
      },
      /**
       * 是否属于不同设备下同名的电流名称
       * @param id 设备id下的电流对应的电流名称
       * @param name 用于不是电流的名称
       */
      isCurrentORDefault(id,name){
        let reslut = name
        const measurement = this.measurements.find((item) => {
          return (
            item.equipment_id === id &&
            item.name === name &&
            item.full_name &&
            item.full_name !== name
          )
        })
        if (measurement && measurement.full_name) {
          return measurement.full_name
        }

        if (name === "电流") {
          const deviceName = (() => {
            if (!this.equip_data || !Array.isArray(this.equip_data.children)) return ""
            const target = this.equip_data.children.find((item) => item.id === id)
            return target && target.name ? target.name : ""
          })()
          const lowerDeviceName = String(deviceName).toLowerCase()
          if (
            lowerDeviceName.includes("1#") ||
            lowerDeviceName.includes("一级") ||
            lowerDeviceName.includes("1st")
          ) {
            return "1#Roots Current"
          }
          if (
            lowerDeviceName.includes("2#") ||
            lowerDeviceName.includes("二级") ||
            lowerDeviceName.includes("2nd")
          ) {
            return "2#Roots Current"
          }
          if (
            lowerDeviceName.includes("3#") ||
            lowerDeviceName.includes("三级") ||
            lowerDeviceName.includes("3rd") ||
            lowerDeviceName.includes("liquid ring") ||
            lowerDeviceName.includes("水环")
          ) {
            return "3#Liquid Ring Current"
          }

          switch (id) {
            case "5f3e0b00-a2fa-11ef-a5dd-0d36d9fdc879": //1#泵
              reslut =  "1#Roots Current"
              break;
            case "d69db4e0-a2fd-11ef-a5dd-0d36d9fdc879"://2#泵
              reslut =  "2#Roots Current"
              break;
            case "c14998b0-a303-11ef-a5dd-0d36d9fdc879"://3#泵
              reslut =  "3#Liquid Ring Current"
              break;       
            default:
              break;
          } 
        }
        return reslut;
      },
      getWsState(measurementItem) {
        if (!measurementItem) return null
        const keyCandidates = []
        const pushKey = (key) => {
          const normalizedKey = typeof key === "string" ? key.trim() : ""
          if (!normalizedKey) return
          if (!keyCandidates.includes(normalizedKey)) keyCandidates.push(normalizedKey)
        }

        pushKey(measurementItem.full_name)
        pushKey(measurementItem.name)

        // 优先按页面静态项对应 key 回溯实时测点配置
        const leftItem = this.leftMeasurementsList.find((item) => {
          return (
            item.key === measurementItem.name ||
            item.name === measurementItem.full_name ||
            item.full_name === measurementItem.full_name
          )
        })
        if (leftItem) {
          pushKey(this.isCurrentORDefault(leftItem.equipment_id, leftItem.name))
          pushKey(leftItem.full_name)
          pushKey(leftItem.name)
          pushKey(leftItem.key)
        }

        for (const key of keyCandidates) {
          if (this.ws_v[key]) return this.ws_v[key]
        }
        return null
      },
    },
    components:{
      Close,
      SelectsTop,
    },
  }
  </script>
  
  <style lang="scss">
  /* 弹框层级 */ 
  .el-overlay{
    z-index: 2010 !important;
  }
  .el-dialog{
    background-color: #12243B !important;
    color: #fff !important;
  }
  .my-header {
    padding-bottom: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
    border-bottom:1.5px solid rgba(198, 194, 194, 0.2);
  }
  .outside-center{
    margin: 15px;
    color: #fff;
    font-size: 16px;
    .left-part{
      width: 348px;
    }
    .right-part{
      width: 1045px;
    }
    .left-part1, .left-part2, .right-part1, .right-part2{
      width: inherit;
      margin: 10px;
      padding: 21px 15px;
      display: flex;
      flex-flow: column;
      border: 1px solid #C6C2C233;
      border-radius: 20px;
      position: relative;
    }
    .left-part1{
      align-items: center;
      .status-button{
        width: 200px;
        height: 100px;
        background-size: cover;
        
      }
    }
    .left-part2,.right-part2{
      margin:20px 10px;
    }
    .right-part1{
      font-size: 12px;
      .tip{
        padding: 10px;
        min-width: 235px;
        top: 15px;
        left: 0px;
        border: 1px solid #495769;
        border-radius: 5px;
      }
      #big-img{
        width: 990px;
        height: 448.53px;
        margin: 20px 20px 20px 0;
      }
    }
    .right-part2{
      height: 215px;
      .model-log{
        
      }
      .date-box-item{
        width: 133.09px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        letter-spacing: 1px; //字间距
        font-size: 10px;
        border-radius: 4px;
        background: linear-gradient(90deg, #01ABB7 0%, #01628C 100%);
      }
      .running-icon{
        width:35px;
        height:35px;
        top:48px;
        right:165px;
      }
      .true-icon{
        width:21px;
        height:21px;
        top:55px;
        right:165px;
      }
    }
    /* 标题字号大小 */ 
    .top_name {
      font-size: 16px !important;
    }
  } 
  .circle-dot{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #B0B0B0;
  }
  .circle-dot-run{
    background: #8DBE1B;
  }
  .meas-table{
    font-family: Noto Sans SC;
    font-size: 12px;
    font-weight: 400;
    td{
      padding: 5px 0px;
    }
    tr{
      background: rgba(73, 87, 105, 0.8);
    }
    tr:nth-child(2n){
      background: rgba(34,51,72,0.8);
    }
  }
  .meas-div{
    font-family: Noto Sans SC;
    font-size: 12px;
    font-weight: 400;
    .div-bg{
      padding: 5px;
      background: rgba(73, 87, 105, 0.8);
    }
    .div-bg:nth-child(2n){
      background: rgba(34,51,72,0.8);
    }
  }
  /** running状态闪烁 */ 
  @keyframes animated-border {
    0% {
      box-shadow: 0 0 0 0 rgba(86,164,244,0.5);
    }
    100% {
      box-shadow: 0 0 0 20px rgba(108,146,230,0);
    }
  }
  .outerAnimation {
    border-radius: 10px;
    animation: animated-border 1.5s infinite;
  }


  /**测点文字闪烁*/
  .blink{ 
    color:#01ABB7; 
    animation: animated-borders 0.5s  ease-in  infinite ;
    /* 其它浏览器兼容性前缀 */
    -webkit-animation: animated-borders 0.5s linear infinite;
    -moz-animation: animated-borders 0.5s linear infinite;
    -ms-animation: animated-borders 0.5s linear infinite;
    -o-animation: animated-borders 0.5s linear infinite;
  }  

  @keyframes animated-borders {
    0% {
      box-shadow: 0 0 0 0 rgba(1,171,183,0.5);
    }
    100% {
      box-shadow: 0 0 0 20px rgba(1,171,183,0);
    }
  }
  // @keyframes changeshadow {  
  //     0%{ text-shadow: 0 0 4px #94c5f3}    
  //     100%{ text-shadow: 0 0 100px #6ab1f3}  
  // }
  // /* 添加兼容性前缀 */
	// @-webkit-keyframes changeshadow {
  //   0%{ text-shadow: 0 0 4px #94c5f3}    
  //   100%{ text-shadow: 0 0 100px #6ab1f3}  
  // }
  // @-moz-keyframes changeshadow {
  //   0%{ text-shadow: 0 0 4px #94c5f3}    
  //   100%{ text-shadow: 0 0 100px #6ab1f3}  
  // }
  // @-ms-keyframes changeshadow {
  //   0%{ text-shadow: 0 0 4px #94c5f3}    
  //   100%{ text-shadow: 0 0 100px #6ab1f3}   
  // }
  // @-o-keyframes changeshadow {
  //   0%{ text-shadow: 0 0 4px #94c5f3}    
  //   100%{ text-shadow: 0 0 100px #6ab1f3}   
  // }
</style>
